import type {Moment} from 'moment-timezone'
import type {fancyOperations, FancyOk} from '@freckle/educator-entities/ts/openapi-clients'
import {fancyClient, extractData} from '@freckle/educator-entities/ts/openapi-clients'

export type StudentGoalT = FancyOk<fancyOperations['getCoursesStudentGoalsR']>[0]

export type StudentGoalMetricT = StudentGoalT['metric']

export const fetchCoursesStudentGoals = (
  courseId: number,
  from: Moment,
  to: Moment,
): Promise<Array<StudentGoalT>> =>
  fancyClient
    .GET('/2/courses/{CoursesStudentGoalsR-CourseId}/student-goals', {
      params: {
        path: {'CoursesStudentGoalsR-CourseId': courseId},
        query: {
          from: from.valueOf(),
          to: to.valueOf(),
        },
      },
    })
    .then(extractData)
